import { render } from "./debatable-badge.vue?vue&type=template&id=31efe7eb"
import script from "./debatable-badge.vue?vue&type=script&lang=js"
export * from "./debatable-badge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__